export const mergeSearchParams = (search = '', nextParams = {}) => {
  const searchParams = new URLSearchParams(search);

  Object.entries(nextParams).forEach(([key, value]) => {
    if (value === null || typeof value === 'undefined') {
      searchParams.delete(key);
      return;
    }

    searchParams.set(key, value);
  });

  return searchParams;
};
